import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {useUserInfiniteQuery} from "./query";
import {debounce} from "../../../utils/debounce";

import MDInput from "materialDashboard/components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import {getScrollHandler, LoadingAdornment} from "../utils";


const UsersAutocomplete = ({ workgroupIds, selectedUsers, setSelectedUsers, fieldProps={}, ...props }) => {
    const {t} = useTranslation(["inputs"]);

    const [hasFocus, setHasFocus] = useState(false);
    const [userSearch, setUserSearch] = useState("");
    let userFilter = {search: userSearch}
    if(workgroupIds?.length > 0){
        userFilter = {...userFilter, workgroup__id__in: workgroupIds}
    }
    const userSearchQuery = useUserInfiniteQuery(userFilter, hasFocus);
    const users = userSearchQuery.data?.pages?.flatMap((page) => page.items) ?? [];

    const userOptions = [
        ...selectedUsers,
        ...users.filter((w) => !selectedUsers.find(({id}) => id === w.id))
    ]

    const handleUserSearch = debounce((value) => {
        setUserSearch(value);
    }, 300);

    return <Autocomplete
        multiple
        id="user-autocomplete"
        options={userOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(user) => `${user.name} ${user.surname} (${user.email})`}
        value={selectedUsers}
        defaultValue={selectedUsers}
        filterOptions={(x) => x}
        loading={userSearch.isFetching}
        onChange={(e, value) => setSelectedUsers(value)}
        onClose={() => handleUserSearch("")}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        ListboxProps={{onScroll: getScrollHandler(userSearchQuery)}}
        renderInput={(params) => (
            <MDInput {...params}
                     onChange={(e) => handleUserSearch(e.target.value)}
                     variant="standard"
                     label={t('usersAutocomplete.label')}
                     placeholder={t('usersAutocomplete.placeholder')}
                     InputProps={{
                         ...params.InputProps,
                         endAdornment: (<LoadingAdornment infiniteQuery={userSearchQuery} params={params} /> )
                     }}
                     {...fieldProps}
            />
        )}
        {...props}
    />
}

export default UsersAutocomplete;